import { AuthGuard } from '@/router/guards/AuthGuard.js'
import AccountSettingsPage from '@/views/Settings/AccountSettingsPage.vue'

export default [
	{
		path: '/account-settings',
		name: 'settings.account-settings',
		component: AccountSettingsPage,
		meta: {
			authGuard: AuthGuard.RequireLoggedIn,
			title: 'Settings'
		}
	}
]
